import { Paper, Typography } from "@mui/material";
import IndustryFilterCard from "./IndustryFilter/IndustryFilterCard";
import IndustryTable from "./IndustryTable/IndustryTable";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { MetaEntitiesEndPointLogic } from "../../../../logic/Admin/MetaEntities/MetaEntitiesEndPointLogic";
import { selectUserData, setIsLoading } from "../../../../features/userSlice";
import { useSelector } from "react-redux";
import Page404 from "../../../Page404/Page403";
import { CheckPermissions } from "../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import SimpleBackdrop from "../../../BackDrop/BackDrop";

interface IndustriesProps {
  oauthTokenHeader: any;
}

const tableHeadings = {
  industry_name: "Industries List",
  created: "Created on",
  created_by: "Created By",
  modified: "Last edited",
  modified_by: "Edited By",
};

const Industry = ({ oauthTokenHeader }: IndustriesProps) => {
  const [selectedIndustries, setSelectedIndustries] = useState(null);
  const [metaIndustryType, setMetaIndustryType] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const response = useSelector(selectUserData);
  const hasViewIndustryPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "view_industries"
  );

  //industry type data
  useEffect(() => {
    const fetchMetaEntitiesDataType = async () => {
      dispatch(setIsLoading(true)); // Dispatch the action to set loading
      setLoading(true);
      try {
        await MetaEntitiesEndPointLogic.getMetaIndustry(
          oauthTokenHeader,
          dispatch
        );
      } catch (error) {
        console.error("Error fetching Meta Entities:", error);
      } finally {
        dispatch(setIsLoading(false)); // Dispatch the action to stop loading
        setLoading(false);
      }
    };

    if (oauthTokenHeader) {
      fetchMetaEntitiesDataType();
    }
  }, [oauthTokenHeader, dispatch]); // Dependency array inside useEffect

  if (!hasViewIndustryPermission) {
    return <Page404 />;
  }
  return (
    <>
      {loading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Paper
            sx={{
              boxShadow: "none",
              padding: "8px 16px 0px",
              borderEndEndRadius: "0px",
              borderBottomLeftRadius: "0px",
            }}
          >
            <Typography fontSize={24}>Industries List</Typography>
            <IndustryFilterCard />
          </Paper>
          <Paper
            sx={{
              boxShadow: "none",
              borderTopLeftRadius: "0px",
              borderTopRightRadius: "0px",
            }}
          >
            <IndustryTable
              tableHeadings={tableHeadings}
              selectedIndustries={selectedIndustries}
              setSelectedIndustries={setSelectedIndustries}
              metaIndustryType={metaIndustryType}
              loading={loading}
              setMetaIndustryType={setMetaIndustryType}
            />
          </Paper>
        </>
      )}
    </>
  );
};

export default Industry;
